import React from 'react';

const TAB_GROUPS = [
  { id: 'shop', label: 'Catalog', tabs: ['overview', 'analytics', 'taxonomy', 'products', 'jewelry'] },
  { id: 'sales', label: 'Sales', tabs: ['orders', 'bespoke', 'coupons', 'reviews'] },
  { id: 'content', label: 'Content', tabs: ['shows', 'site'] },
  { id: 'tools', label: null, tabs: ['advanced'] },
];

const TABS = [
  { id: 'overview', label: 'Overview', short: 'Overview' },
  { id: 'analytics', label: 'Analytics', short: 'Stats' },
  { id: 'taxonomy', label: 'Categories', short: 'Categories' },
  { id: 'products', label: 'Products', short: 'Products' },
  { id: 'jewelry', label: 'Jewelry types', short: 'Jewelry' },
  { id: 'orders', label: 'Orders', short: 'Orders' },
  { id: 'bespoke', label: 'Custom requests', short: 'Custom' },
  { id: 'coupons', label: 'Coupons', short: 'Coupons' },
  { id: 'reviews', label: 'Reviews', short: 'Reviews' },
  { id: 'shows', label: 'Shows', short: 'Shows' },
  { id: 'site', label: 'Site', short: 'Site' },
  { id: 'advanced', label: 'Advanced', short: 'Advanced' },
];

const TAB_HINTS = {
  taxonomy: 'Categories and shop groups for your catalog.',
  products: 'Add, edit, or remove products in each category.',
  jewelry: 'Add customization types for the product editor dropdown (photo locket, chain, etc.).',
  orders: 'Paid shop orders — shipping, labels, and cart customizations.',
  bespoke: 'Custom jewelry design enquiries from /custom-jewelry with outfit photos.',
  advanced: 'Export or validate catalog backup.',
};

const TAB_BY_ID = Object.fromEntries(TABS.map((t) => [t.id, t]));

const PANELS_WITH_OWN_HERO = new Set([
  'overview',
  'analytics',
  'products',
  'orders',
  'bespoke',
  'coupons',
  'reviews',
  'shows',
  'site',
]);

export default function AdminNav({ active, onChange, dirty }) {
  const current = TAB_BY_ID[active] || TABS[0];
  const directSave =
    active === 'site' ||
    active === 'shows' ||
    active === 'orders' ||
    active === 'bespoke' ||
    active === 'coupons' ||
    active === 'reviews' ||
    active === 'analytics';

  const showContext = !PANELS_WITH_OWN_HERO.has(active) && active !== 'site';
  const contextHint = TAB_HINTS[active];

  return (
    <div className="admin-shell-nav" aria-label="Admin sections">
      <div className="admin-shell-nav__scroll">
        <div className="admin-shell-nav__groups" role="tablist">
          {TAB_GROUPS.map((group, gi) => (
            <div key={group.id} className="admin-shell-nav__group">
              {group.label ? (
                <span className="admin-shell-nav__group-label d-none d-xl-inline">{group.label}</span>
              ) : null}
              <div className="admin-shell-nav__tabs">
                {group.tabs.map((tabId) => {
                  const t = TAB_BY_ID[tabId];
                  if (!t) return null;
                  const isActive = active === t.id;
                  return (
                    <button
                      key={t.id}
                      type="button"
                      role="tab"
                      id={`admin-tab-${t.id}`}
                      aria-selected={isActive}
                      aria-controls={`admin-panel-${t.id}`}
                      className={`admin-shell-nav__tab${isActive ? ' admin-shell-nav__tab--active' : ''}`}
                      onClick={() => onChange(t.id)}
                    >
                      <span className="d-none d-md-inline">{t.label}</span>
                      <span className="d-md-none">{t.short}</span>
                    </button>
                  );
                })}
              </div>
              {gi < TAB_GROUPS.length - 1 ? (
                <span className="admin-shell-nav__divider d-none d-lg-inline" aria-hidden />
              ) : null}
            </div>
          ))}
        </div>
      </div>

      {dirty && !directSave ? (
        <div className="admin-shell-nav__meta">
          <span className="admin-shell-nav__badge admin-shell-nav__badge--draft">Unsaved catalog</span>
        </div>
      ) : null}

      {showContext && contextHint ? (
        <div
          className="admin-shell-nav__context"
          role="tabpanel"
          id={`admin-panel-${active}`}
          aria-labelledby={`admin-tab-${active}`}
        >
          <span className="admin-shell-nav__context-title">{current.label}</span>
          <span className="admin-shell-nav__context-hint">{contextHint}</span>
        </div>
      ) : null}
    </div>
  );
}
